/* /tilbud/still/:key – one view of the system at PDF size (1040×640, compact), without the browser chrome.
   Used only to capture the stills the PDF needs (scripts/capture_tilbud_stills.py); the web page renders the live components. */
import { useParams } from "react-router-dom";
import { SkView } from "../components/proposal/sk/Shots";
import "../proposal.css";

const SIZES = { full: [1360, 820], compact: [1040, 640], narrow: [390, 760] };

export default function TilbudStillPage() {
  const { key } = useParams();
  const params = new URLSearchParams(window.location.search);
  const mode = SIZES[params.get("mode")] ? params.get("mode") : "compact";
  const [w, h] = SIZES[mode];
  return (
    <div className="kvp kvl" style={{ width: w, height: h, overflow: "hidden", background: "#fff" }} data-testid="tilbud-still" data-view={key} data-mode={mode}>
      <SkView k={key} mode={mode} ns="sk-still" toast={false} />
    </div>
  );
}
